<template>
	<el-table v-loading="tableLoading" :data="data">
		<el-table-column prop="name" label="工艺参数名"></el-table-column>
		<el-table-column prop="max" label="最大值" width="80"></el-table-column>
		<el-table-column prop="min" label="最小值" width="80"></el-table-column>
		<el-table-column prop="avg" label="平均值" width="80"></el-table-column>
		<el-table-column prop="unit" label="单位" width="80"></el-table-column>
	</el-table>
</template>

<script>
	import * as teachGroupRequest from '@/network/requests/techGroup'
	export default {
		props: {
			groupId: {
				type: String,
			},
		},
		data() {
			return {
				data: [],
				tableLoading: false,
			}
		},
		methods: {
			/**
			 * 获取参数组详情。
			 */
			getTeachGroupsDetail() {
				if (!this.groupId) {
					this.tableLoading = false
					return
				}

				this.tableLoading = true
				teachGroupRequest
					.queryTechGroupDetailById(this.groupId)
					.then(res => {
						this.data = res
					})
					.finally(() => {
						this.tableLoading = false
					})
			},
		},
		created() {
			this.getTeachGroupsDetail()
		},
	}
</script>

<style></style>
